const FILENAME_PATTERN = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i;

/** Сохраняет ответ axios с responseType: 'blob' как файл; имя — из Content-Disposition. */
export const saveBlobResponse = (response, fallbackName) => {
    const disposition = response.headers['content-disposition'] || '';
    const filename = decodeURIComponent(disposition.match(FILENAME_PATTERN)?.[1] || fallbackName);

    const url = URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
};

/**
 * При responseType: 'blob' тело ошибки (422/500 JSON) тоже приходит Blob'ом.
 * Возвращает ошибку с разобранным JSON в response.data — её понимают utils/httpErrors.
 */
export const withParsedBlobError = async (error) => {
    const data = error?.response?.data;
    if (!(data instanceof Blob)) return error;

    try {
        error.response.data = JSON.parse(await data.text());
    } catch {
        error.response.data = {};
    }
    return error;
};
